















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ChartHeader from './ChartHeader.vue'
@Component({
  name: 'BarDashed',
  components: { Chart, ChartHeader }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string
  @Prop({}) private dataList!: any
  @Prop({ default: '均分' }) private type!: string

  private chartId: string = ''
  private legend: any[] = [{ name: '参考标准', color: '#666666' }, { name: this.type, color: this.color }]
  private option: any = {
    // animation: false,
    silent: true, // 禁用地图的hover事件
    grid: {
      top: 20,
      right: 10,
      left: 30,
      bottom: 75
    },
    title: {
      // subtext: '占比（%）'
    },
    // legend: {
    //   data: ['参考标准', '当前占比'],
    //   icon: 'circle',
    //   right: 0,
    //   top: 10,
    //   itemWidth: 6
    // },
    xAxis: [{
      type: 'category',
      data: ['很差', '较差', '一般', '良好', '优秀'],
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        interval: 0
      }
    }],
    yAxis: [{
      type: 'value',
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#999999'
      }
    }],
    series: [
      {
        name: '参考标准',
        type: 'bar',
        data: [],
        itemStyle: {
          borderWidth: 1,
          borderColor: '#666',
          borderType: 'dotted',
          // color: 'transparent',
          color: '#FFFFFF'
        },
        barWidth: 20

      },
      {
        name: this.type,
        type: 'bar',
        barGap: '-81.5%',
        data: [],
        label: {
          color: '#333',
          show: true,
          position: 'top',
          // formatter: '{c}%'
          formatter: (params:any) => {
            let index = params.dataIndex
            let value = parseFloat(params.value)
            let normValue = parseFloat(this.dataList[index].values[1])
            let val = (value - normValue).toFixed(1)
            if (value - normValue > 0) {
              val = '+' + val
            }
            return val + (this.type === '均分' ? '' : '%')
          }
        },
        itemStyle: {
          color: this.color
        },
        barWidth: 12
      }
    ]
  }
  get chart() {
    return this.$refs.chart as any
  }
  @Watch('dataList', { immediate: true, deep: true })
  onDataChange(val: any) {
    if (!this.dataList.length) return
    if (this.dataList.length >= 6) {
      // console.log('设置DataZoom')
      this.option.dataZoom = [
        {
          bottom: 0,
          type: 'slider',
          startValue: 0,
          endValue: 5,
          backgroundColor: '#fff',
          fillerColor: '#eee',
          dataBackground: {
            lineStyle: {
              color: '#fff'
            },
            areaStyle: {
              color: '#fff'
            }
          }
        }]
    } else {
      // console.log('取消DataZoom')
      this.option.dataZoom = null
    }
    let names:any = []
    let data:any = []
    let normData:any = []
    this.dataList.map((item: any) => {
      names.push(this.$fn.substring(item.name, 5))
      data.push(item.values[0])
      normData.push(item.values[1])
    })
    this.option.xAxis[0].data = names
    this.option.series[0].data = normData
    this.option.series[1].data = data
    this.$nextTick(() => {
      this.chart.setOption(this.option)
    })
  }
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
  }
}
